import { Component, OnInit } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-term-info',
  templateUrl: './term-info.component.html',
  styleUrls: ['./term-info.component.scss'],
  
})
export class TermInfoComponent  implements OnInit {

  constructor() { }

  ngOnInit() {}

}
